"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bodyStyle = void 0;
exports.bodyStyle = "\n    body {\n        margin: 0;\n        min-width: 280px;\n        font-family: Unipol;\n        font-size: 16px;\n        overflow-x: hidden;\n        color: #333;\n        max-width: none !important;\n    }\n";
